import en from './locales/en';
import nl from './locales/nl';

export const resources = {
	en: { translation: en },
	nl: { translation: nl },
};